export const PROCESSO_ROUTE = {
    SOLICITACAO_FORM: 'solicitacao',
    SOLICITACAO_VIEW: 'solicitacao-view',
    REQUERIMENTO_RECONSIDERACAO: 'requerimento-reconsideracao',
    REQUERIMENTO_RECURSO: 'requerimento-recurso',
    RECURSO: 'recurso',
    CORRETOR_REGISTRO: 'corretor-registro',
    REVISAO_CLASSIFICACAO: 'revisao-classificacao',
    LEGADO_RECYCLE: 'reciclar-legado',
}
